import React from 'react';
import classNames from 'classnames';
import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const NodePartner = ({ entity, className }) => {
  const classes = classNames(className, 'NodePartner');
  const node = entity.toJS();
  const title = node.title[0].value;
  // #TODO: Add a responsive image component once ready
  const logo = node.field_media_item?.[0]?.styles.original;
  const url = node.field_link[0]?.alias || node.field_link[0]?.uri;

  return (
    <div className={classes}>
      <CoreLink href={url}>
        {logo && (
          <div className="NodePartner__logo">
            <Image src={logo} alt={title} />
          </div>
        )}
        <div className="NodePartner__content">
          <p className="NodePartner__title">{title}</p>
        </div>
      </CoreLink>
    </div>
  );
};

export default NodePartner;
